import { log } from './utils'

export default function logout () {
  return Promise.resolve(log('暂无可用的登出方式'))
}
